import netsChatChangeName from './nets-chat-change-name';

export default angular
  .module('app.chat-change-name', [])
  .component('netsChatChangeName', netsChatChangeName);
